"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContainer = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const FooterContainer = exports.FooterContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  display: 'flex',
  alignSelf: 'flex-end',
  padding: theme.spacing(4, 3, 4, 3),
  background: theme.palette.common.white,
  marginTop: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 4)
  }
}));
const Content = exports.Content = (0, _mui.styled)(_mui.ScopedCssBaseline, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isLoading'])
})(({
  theme,
  isLoading
}) => ({
  overflowY: 'auto',
  maxHeight: '100%',
  height: isLoading ? '100%' : 'auto',
  padding: theme.spacing(0, 2),
  margin: theme.spacing(0, 2)
}));
